<script lang="ts">
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import { tooltip } from "$actions/tooltip";
  import cx from "classnames";
  import { FilledUp } from "$components/+shared/OVIcon";

  export let variant: "horizontal-small" | "vertical-small" | "vertical-regular";
  export let count: number;
  export let isSelected: boolean = false;
  export let disabled: boolean = false;
  export let addUpvote: () => void;
  export let removeUpvote: () => void;

  // save just the intial count and update it on click
  let _count = count;
  let _isSelected = isSelected;
  function handleClick() {
    if (_isSelected) {
      _count -= 1;
      removeUpvote();
    } else {
      _count += 1;
      addUpvote();
    }
    _isSelected = !_isSelected;
  }

  $: variants = {
    "vertical-small": cx(
      "flex-col text-xxs dark:hover:text-gray-300 hover:text-gray-500 transition-colors",
      { "text-gray-500 dark:text-gray-200": _isSelected },
      { "text-gray-400": !_isSelected }
    ),

    "vertical-regular": cx(
      "flex-col gap-[1px] px-2.5 pt-1.5 pb-2 text-xs border-[0.5px] rounded",
      "enabled:dark:hover:bg-white/5",
      {
        "border-informational-green/50 dark:bg-white/10 bg-gray-100 enabled:hover:bg-gray-200 text-gray-500 dark:text-gray-200":
          _isSelected,
      },
      {
        "border-black/20 dark:border-white/10 enabled:hover:bg-gray-100 text-gray-400":
          !_isSelected,
      }
    ),

    "horizontal-small": cx(
      "flex-row gap-[3px] min-w-[36px] pl-[5px] pr-1.5 h-[20px] text-xxs border-[0.5px] rounded",
      "enabled:dark:hover:bg-white/5 enabled:hover:bg-black/5",
      {
        "border-informational-green/50 bg-gray-100 dark:bg-white/10 enabled:hover:bg-gray-200 text-gray-500 dark:text-gray-200":
          _isSelected,
      },
      {
        "border-black/20 dark:border-white/10 enabled:hover:bg-gray-100 text-gray-400":
          !_isSelected,
      }
    ),
  };
</script>

<button
  title={disabled ? "Join the community to upvote" : "Upvote"}
  class={cx(
    "flex items-center font-medium leading-none transition-colors disabled:cursor-not-allowed",
    variants[variant]
  )}
  use:tooltip
  {disabled}
  on:click|preventDefault={handleClick}
>
  <OVIcon
    icon={FilledUp}
    class={cx({ "text-informational-green": _isSelected }, { "opacity-50": !_isSelected })}
    size="w-[14px]"
  />
  {_count}
</button>
